
<template>
    
        <c-popup v-if="isShow" :show="isShow" :type="type"><mars-view class="more-service-popup-box"><mars-view class="title">
            法律服务方说明
        </mars-view><mars-view class="title-close" @click.native.stop="close"></mars-view><mars-view class="main-content">
            法律服务方包含：律临认证律师、瀛和律师机构、法律部落、效律网、大律科技、湖南旷真（北京）律师事务所、君达法律咨询。
        </mars-view></mars-view></c-popup>
    
</template>

<script>
/* globals getApp, Page, swan, getCurrentPages, globalData */
import Popup from "../common/newPopup.vue";
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    }
  },
  components: {
    'c-popup': Popup
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.more-service-popup-box {
  position: relative;
  background-color: #fff;
  padding: 4.35vw 4.11vw 0;
}
.more-service-popup-box .title-close {
  position: absolute;
  right: 4.11vw;
  top: 5vw;
  width: 3.14vw;
  height: 3.14vw;
  background-image: url('https://lvlin-base.cdn.bcebos.com/law/pages/clue-collection/clue-collection-popup-close-icon.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.more-service-popup-box .title {
  font-family: "PingFang SC";
  font-size: 4.35vw;
  font-style: normal;
  text-align: center;
  font-weight: 500;
  line-height: 4.35vw;
  padding-bottom: 4.59vw;
}
.more-service-popup-box .main-content {
  margin-top: 5vw;
  padding-bottom: 23.43vw;
  width: 100%;
  font-family: PingFangSC-Regular;
  font-size: 3.86vw;
  color: #1f1f1f;
  line-height: 6.76vw;
  font-weight: 400;
}

</style>
